import type { HTMLAttributes } from "react";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: "neutral" | "strong" | "danger" | "success" | "warning" | "info";
}

/** Статус документа: прямоугольный, заглавными. */
export function Badge({ tone = "neutral", className, ...rest }: BadgeProps) {
  return <span className={className ? `w-badge ${className}` : "w-badge"} data-tone={tone === "neutral" ? undefined : tone} {...rest} />;
}
